import React, { useState, useEffect } from "react";
import { View, Image, Text, Pressable, StyleSheet, Animated } from "react-native";

import { store } from "../../store/store";
import { refreshOrder } from "../../utils/services/oms/OMSUtils";
import { checkIfShowA2shBtn, onPressA2HS } from "../../utils/services/A2HSUtils";
import { addFontFamilylato, getImagePath, vibrateDevice } from "../../utils/services/CommonUtils";

import { WAUpdateToggleView } from "../../utils/widgets/Common-Widget";

import { ScreenRoute } from "../../utils/constants/ScreenRouteConstant";

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";

const OrderSuccess = (props) => {

    const reduxState = store.getState()
    const animationValue = new Animated.Value((AppTheme.appWidth))

    const [orderId, setOrderId] = useState('')
    const [waState, updateWAState] = useState({
        optInState: reduxState.whatsappOptInState,
        isOpted: reduxState.whatsappOptInState == 1 ? true : false
    })
    const [isShowA2hsCta, setIsShowA2hsCta] = useState(false)

    useEffect(() => {
        if (props?.route?.params?.orderId) {
            setOrderId(props?.route?.params['orderId']);
        }
        checkIfShowA2shBtn(setIsShowA2hsCta);
        vibrateDevice()
    }, [])

    const redirectToOrders = () => {
        refreshOrder()
        if (props.navigation.canGoBack())
            props.navigation.popToTop();
        props.navigation.replace(ScreenRoute.orders)
    }

    useEffect(() => {
        Animated.timing(animationValue, {
            toValue: 0,
            duration: 500,
            delay: 4000,
            useNativeDriver: true
        }).start() // < Don't forget to start!

    }, [])

    return (
        <View style={{ position: 'relative' }}>
            <View style={styles.flexCol}>
                {isShowA2hsCta ? <Pressable onPress={() => { onPressA2HS() }}>
                    <Animated.View style={[AppStyles.flexRowCenter, {
                        width: animationValue.interpolate({
                            inputRange: [0, 100],
                            outputRange: ['0%', '100%'],
                        }), maxWidth: 207, borderColor: AppTheme.color.white, borderWidth: 2, borderRadius: 24, padding: 10, minWidth: 45, position: 'fixed', top: 16, left: 16,
                    }]}>
                        <Image style={{ marginLeft: 4 }} source={{ uri: getImagePath('/images/icons/a2hs_white.svg'), width: 14, height: 19.5 }} />

                        <Text numberOfLines={1} style={[TextStyle.text14xb, { flex: 1, color: AppTheme.color.white, paddingLeft: 5 }]}>{' Add app to home screen '}</Text>
                    </Animated.View> </Pressable> : null}
                <Image source={{ uri: getImagePath('/images/icons/order_sucess.svg'), width: 139, height: 132 }}></Image>
                <Text style={[TextStyle.text14, { width: 250, marginTop: 16, color: '#FFFFFF', textAlign: 'center' }]}>
                    Your order number #{orderId} is successfully placed</Text>
                <Text style={[TextStyle.text14b, styles.seeOrderText]}
                    onPress={() => { redirectToOrders() }}>
                    View Order</Text>
            </View>
            <View style={[AppStyles.bottomFix, AppStyles.m16]}>
                <WAUpdateToggleView activity={'order'} waState={waState} updateWAState={updateWAState} /></View>
        </View>
    )
}

export default OrderSuccess;

const styles = StyleSheet.create(addFontFamilylato({
    flexCol: { flex: 1, display: 'flex', minHeight: '100vh', justifyContent: 'center', flexDirection: "column", alignItems: 'center', backgroundColor: AppTheme.color.green.primary },
    seeOrderText: { width: 162, marginTop: 16, textAlign: 'center', color: AppTheme.color.green.primary, paddingVertical: 14, backgroundColor: '#FFFFFF', borderColor: AppTheme.color.green.primary, borderRadius: 24, borderWidth: 2 }
}))